import { DateSelector } from "source/shared/components"

export function Date({ customField }: { customField: any }) {
  const fieldName =
    customField.relationships.field_definition.data.attributes.name
  const fieldValue =
    customField.relationships.field_data?.data[0]?.attributes?.value ||
    "No value"

  return (
    <div key={customField.id} className="mb-2">
      <DateSelector
        name={`customField - ${fieldName}`}
        initialValue={fieldValue}
        label={fieldName}
        onChange={() => { }}
      />
    </div>
  )
}
